import api from '../../../services/api';

export const getConfigs = () => api.get('/smm/config').then(r => r.data);
export const upsertConfig = (payload) => api.post('/smm/config', payload).then(r => r.data);
export const deleteConfig = (id) => api.delete(`/smm/config/${id}`).then(r => r.data);
